import { Button, IconButton, styled, Typography } from '@mui/material';

export const FromContainer = styled('div')`
  width: 671px;
  background: rgba(255, 255, 255, 0.7);
  border: 1px solid ${({ theme }) => theme.palette.primary.grey};
  backdrop-filter: blur(10px);
  border-radius: 15px;
  padding: 36px 25px;

  @media (max-width: 1023px) {
    width: 100%;
    padding: 16px 8px;
    margin-bottom: 110px;
    margin-right: 0px;
  }
`;

export const FormAndPreviewW = styled('div')`
  display: flex;
  align-items: flex-start;
  position: relative;
`;

export const ButtonsW = styled('div')`
  display: flex;
  flex-direction: column;
  @media (max-width: 1023px) {
    flex-direction: row;
    column-gap: 16px;
  }
`;

export const LabelTitle = styled(Typography)(({ theme }) => ({
  fontWeight: 700,
  fontSize: '14px',
  lineHeight: '24px',
  color: theme.palette.primary.p080,
  marginBottom: '16px',
  marginLeft: '10px',
  [theme.breakpoints.down('desktop')]: {
    marginBottom: '8px',
  },
}));

export const HeaderW = styled('div')`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 24px;
`;

export const HeaderLeft = styled('div')`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const HeaderAuthorInfo = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const HeaderAuthorName = styled(Typography)`
  font-size: 14px;
  font-weight: 500;
  line-height: 18px;
  color: ${({ theme }) => theme.palette.primary.main};
`;

export const HeaderDateTime = styled(Typography)`
  font-size: 12px;
  line-height: 14px;
  color: ${({ theme }) => theme.palette.primary.p030};
`;

export const DeleteButtonW = styled(Button)`
  height: 48px;
  padding: 0 24px;
  background-color: ${({ theme }) => theme.palette.white.main};
  color: ${({ theme }) => theme.palette.primary.main};
  border: ${({ theme }) => `1px solid ${theme.palette.primary.grey}`};
  border-radius: 8px;
  font-weight: 600;
  font-size: 14px;
  text-transform: none;
  flex-shrink: 0;

  &:hover {
    background-color: ${({ theme }) => theme.palette.white.p100};
    border-color: ${({ theme }) => theme.palette.white.light};
  }

  @media (max-width: 1023px) {
    height: 40px;
    padding: 0 16px;
    font-size: 12px;
  }
`;

export const RichEditorW = styled('div')`
  @media (max-width: 1023px) {
    margin-bottom: 8px;
  }
`;

export const CloseButtonW = styled(IconButton)`
  margin-left: auto;
  position: fixed;
  top: 79px;
  right: 88px;
`;

export const PreviewTitle = styled(Typography)`
  font-size: 14px;
  line-height: 10px;
  color: ${({ theme }) => theme.palette.primary.p030};
  position: absolute;
  top: -32px;
`;
